import React from "react";

export default function ArrowLeftIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask id="mask0_2653_864"  maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect x="16" y="16" width="16" height="16" transform="rotate(-180 16 16)" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_2653_864)">
            <path d="M10.6628 1.79484L11.3718 2.50384L5.87566 8L11.3718 13.4962L10.6628 14.2052L4.45766 8L10.6628 1.79484Z" fill="#1C1B1F"/>
        </g>
    </svg>
  );
}
